export default class Results {

    constructor(props) {
        const instance = this.constructor.instance;
        if (instance) {
            return instance;
        }

        this.constructor.instance = this;

        this.euvias = [];
        this.moreEuvias = false;
        this.videos = [];
        this.moreVideos = false;
        this.locations = [];
        this.moreLocations = false;
    }

    reset() {
        this.euvias = [];
        this.videos = [];
        this.locations = [];
        this.moreEuvias = this.moreVideos = this.moreLocations = false;
    }

    setEuvia(euvias) {
        this.euvias = euvias;
    }

    appendEuvia(euvia) {
        this.euvias.push(euvia);
    }

    hasEuvia() {
        return this.euvias.length;
    }

    setVideos(videos) {
        this.videos = videos;
    }

    appendVideo(video) {
        this.videos.push(video);
    }

    hasVideos() {
        return this.videos.length;
    }

    setLocations(locations) {
        this.locations = locations;
    }

    appendLocation(location) {
        this.locations.push(location);
    }

    hasLocations() {
        return this.locations.length;
    }

    hasResults() {
        return this.euvias.length && this.videos.length && this.regions.length;
    }

}